module.exports = __webpack_public_path__ + "static/media/howtobefat.7e37e051.png";